import type { ISO8601 } from '@app/constants/Misc'

import { createSelector } from '@app/utils/createSelector'
import moment from '@app/utils/moment'
import { catchFetchDataError } from '@app/utils/performFetchData'

import { getTimezones } from '@app/packages/api/v2/actions/timezones'
import type { ApiTimeZone } from '@app/packages/api/v2/types/entities'
import { createPromise } from '@app/packages/thunkSelector/promiseState'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'

import { callV2Api } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'
import { routingDateSelector } from '@app/store/slices/routing'

const timezonesSlice = createReduxSlice<{ loadedAt: ISO8601; timezones: ApiTimeZone[] }>('timezones')

export const timezonesThunkSelector = createSelector([timezonesSlice.selector, routingDateSelector], (meta, date) =>
  createLoadable(c => {
    if (!meta || moment(meta.loadedAt).add(30, 'minutes').isBefore(date)) {
      const loadedAt = date.format()
      return c.load(
        createPromise('Timezones must be fetched', loadedAt ?? '', async dispatch => {
          const resp = await dispatch(callV2Api(getTimezones())).catch(catchFetchDataError(dispatch, 'Timezones fetch failed'))
          dispatch(timezonesSlice.set({ loadedAt, timezones: resp.data }))
        })
      )
    }
    return meta.timezones
  })
)
